module.exports = __webpack_public_path__ + "static/img/lijun2.40d4f48a.png";